<script setup lang="ts">
import { RouterView } from 'vue-router'
import SensoryHeader from '@/components/SensoryHeader.vue'
import ToastNotification from '@/components/ToastNotification.vue'
import SensoryFooter from '@/components/SensoryFooter.vue'
import GuestSessionBar from '@/components/Guest/GuestSessionBar.vue'
</script>

<template>
  <sensory-header></sensory-header>
  <guest-session-bar />
  <main class="content-wrapper">
    <RouterView />
  </main>
  <sensory-footer />
  <toast-notification></toast-notification>
</template>

<style lang="scss" scoped>
.content-wrapper {
  min-height: calc(100vh - 13.5rem);
}
</style>

<style lang="scss">
#app,
.toaster__wrapper {
  .y-color-kraft {
    color: var(--secondary-accent-color);
  }
  .y-combobox__container__top-content__input {
    color: var(--secondary-brand-color);
  }
  .y-combobox__container:focus-within {
    outline: 0.25rem auto var(--secondary-brand-color);
  }

  .y-toggle__switch .y-toggle__input:checked + .y-toggle__slider {
    background-color: var(--secondary-brand-color);
    border: 2px solid var(--secondary-brand-color);
  }
  .y-progress__bar__fill--dark {
    background: var(--secondary-brand-color);
  }
  .y-progress__label--dark {
    color: var(--secondary-brand-color);
  }
  button.y-button__button--primary {
    background-color: var(--primary-brand-color);
    &:hover,
    &:active {
      background-color: var(--primary-brand-color);
    }
  }

  button.y-button__button--secondary {
    background-color: var(--secondary-brand-color);
    &.y-button__button--disabled {
      background: var(--ych-grey-200);
    }
  }

  .toaster__inner__buttons .y-button__button--primary:hover,
  .toaster__inner__buttons
    .y-button__button--primary:active
    label.y-button__button--selectable.y-button__button--checked.y-button__button--secondary {
    background-color: var(--secondary-brand-color);
  }

  label.y-button__button--selectable.y-button__button--secondary {
    border: 2px solid var(--secondary-brand-color);
    color: var(--secondary-brand-color);
    svg path {
      fill: var(--secondary-brand-color);
    }
    &.y-button__button--checked {
      color: var(--ych-white);
      svg path {
        fill: var(--ych-white);
      }
    }
  }
}
</style>
